<template>
  <!-- eslint-disable-next-line vue/no-mutating-props -->
  <md-dialog :md-active.sync="active">
    <md-dialog-title>
      <div>
        <md-icon class="md-size-2x">history</md-icon>
      </div>
      <md-button
        class="md-button md-just-icon history-close md-simple"
        @click="$emit('update:active', false)"
      >
        <md-icon>cancel</md-icon>
      </md-button>
    </md-dialog-title>
    <md-dialog-content>
      <a
        v-for="(item, index) in items"
        :key="index"
        href
        class="history-list"
        :class="{ disabled: !checkHistoryLink(item) }"
        @click.prevent="openLink(item)"
      >
        <img v-if="item.icon" :src="mixinGetFilePath(item.icon, 'O')" />
        <small>
          {{
            displayTimeZone(new Date(item.createdAt * 1000), 'HH:mm YYYY-MM-DD')
          }} </small
        ><br />
        <span class="name-history">
          {{ item.name }}
        </span>
        <md-icon>chevron_right</md-icon>
      </a>
    </md-dialog-content>
    <md-dialog-actions v-if="service">
      <md-button
        class="md-fab md-primary history-add md-simple md-just-icon"
        @click="checkService(service)"
      >
        <md-icon>add</md-icon>
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import timeZone from '@/mixins/timeZone';

export default {
  mixins: [timeZone],
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    service: {
      type: Object,
      required: false,
    },
  },
  methods: {
    openLink(item) {
      if (this.checkHistoryLink(item)) {
        this.$emit('open-link', item.url);
      }
    },
    checkService(service) {
      this.$emit('check-service', service);
    },
    checkHistoryLink(history) {
      if (Math.floor(Date.now() / 1000) <= Number(history.expires)) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/public/_public-history-dialog.scss';
</style>
